import React from 'react';
import styled from "styled-components";
import Icon from "@atoms/icon";
import ConvertPixelToRem from "@helpers/convert.rem";
import Link from "next/link";
import {isEmpty} from "@helpers/helpers";
import ChevronLeftIcon from '@icons/chevron-left.svg';

function LandingTile({items, className, iconsClassName, iconSize, crossOverLink = false}) {
    return (
        <div className="row">
            {
                items.map((item, key) =>
                    <div key={key} className={"col-12 col-lg " + (key > 0 ? 'mt-8 mt-lg-0' : '')}>
                        {
                            (isEmpty(item.crossOverLink) || !item.crossOverLink) ?
                                <Link href={item.href ?? '/'} as={item.hrefAs}>
                                    <a>
                                        <Card className="bg-info bg-info-hover rounded-8 d-flex align-items-center justify-content-between">
                                            <Tile className="d-flex align-items-center">
                                                <Icon width={iconSize ?? 16} className={"icon-" + key + (iconsClassName ? ' ' + iconsClassName : '')}>{item.icon}</Icon>
                                                <span className="h3-normal mr-16">{item.title}</span>
                                            </Tile>
                                            <Icon className="tile-arrow-left"><ChevronLeftIcon strokeWidth="2"/></Icon>
                                        </Card>
                                    </a>
                                </Link>
                                :
                                <a href={item.hrefAs}>
                                    <Card className="bg-info bg-info-hover rounded-8 d-flex align-items-center justify-content-between">
                                        <Tile className="d-flex align-items-center">
                                            <Icon width={iconSize ?? 16} className={"icon-" + key + (iconsClassName ? ' ' + iconsClassName : '')}>{item.icon}</Icon>
                                            <span className="h3-normal mr-16">{item.title}</span>
                                        </Tile>
                                        <Icon className="tile-arrow-left"><ChevronLeftIcon strokeWidth="2"/></Icon>
                                    </Card>
                                </a>
                        }
                    </div>
                )
            }
        </div>
    )
}

export default LandingTile;

// styles
const Card = styled.div`
  padding: 0 24px;

  height: 80px;

  .tile-arrow-left {
    width: 16px;
    height: 16px;
  }

  @media (max-width: ${props => props.theme.screenSmMax}) {

    height: 64px;

    .tile-arrow-left {
      width: 14px;
      height: 14px;
    }
  }
`;

const Tile = styled.div`


  @media (max-width: ${props => props.theme.screenSmMax}) {
    .h3 {
      font-size: ${ConvertPixelToRem(15)};
    }

    span.h3-normal {
      font-weight: 500;
    }
  }
`;

